/**
 * Module dependencies.
 */

import styled from 'styled-components';

/**
 * Placement: inside navy price row (white icon/text) vs below white CTA button (dark icon/text).
 */

export type RewardsPointsPlacement = 'priceBlock' | 'ctaBelow';

/**
 * `Root` styled component.
 */

const Root = styled.div.withConfig({
  shouldForwardProp: prop => !['placement'].includes(prop)
})<{ placement: RewardsPointsPlacement }>`
  align-items: center;
  color: ${({ placement }) => (placement === 'priceBlock' ? '#ffffff' : '#0a0a28')};
  display: flex;
  flex-shrink: 0;
  font-family: Raleway, sans-serif;
  font-size: 11px;
  font-weight: 600;
  gap: 6px;
  justify-content: center;
  line-height: 16px;
  margin-top: ${({ placement }) => (placement === 'priceBlock' ? '4px' : '12px')};
  text-align: center;

  svg {
    flex-shrink: 0;
  }

  @media (min-width: 376px) {
    font-size: 12px;
    line-height: 18px;
  }
`;

/**
 * `RewardsPointsInline` component.
 */

interface RewardsPointsInlineProps {
  id?: string;
  label: string;
  placement?: RewardsPointsPlacement;
}

export function RewardsPointsInline({ id, label, placement = 'priceBlock' }: RewardsPointsInlineProps) {
  return (
    <Root data-name={placement === 'ctaBelow' ? 'points-cta' : 'points'} id={id} placement={placement}>
      <svg
        aria-hidden
        fill={'none'}
        height={'12'}
        viewBox={'0 0 12 12'}
        width={'12'}
        xmlns={'http://www.w3.org/2000/svg'}
      >
        <path
          d={
            'M5.30447 1.46898C5.55696 0.843104 6.44305 0.843104 6.69554 1.46898L7.66418 3.87004C7.69956 3.95775 7.78142 4.01799 7.87569 4.02568L10.3088 4.22421C10.9685 4.27804 11.2401 5.09775 10.7431 5.53489L8.89684 7.15873C8.82851 7.21882 8.79823 7.3113 8.81778 7.40016L9.40817 10.0837C9.55565 10.754 8.79981 11.2539 8.24068 10.8558L6.14501 9.36366C6.05822 9.30186 5.94179 9.30186 5.855 9.36366L3.75933 10.8558C3.2002 11.2539 2.44436 10.754 2.59184 10.0837L3.18223 7.40017C3.20178 7.3113 3.1715 7.21882 3.10317 7.15873L1.25685 5.5349C0.759822 5.09777 1.03145 4.27804 1.69117 4.22421L4.12432 4.02568C4.21859 4.01799 4.30045 3.95775 4.33584 3.87004L5.30447 1.46898Z'
          }
          fill={'currentColor'}
        />
      </svg>

      <span>{label}</span>
    </Root>
  );
}
